import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import {userRoute} from "pages/user/user.routes";

const allowedRoutes = [userRoute.classDetail, userRoute.map, userRoute.searchOnline];

export const ProtectedRoute = ({children}) => {
    const {pathname} = useLocation();
    const {token} = useAuth();

    if (token) {
        return children;
    }

    const isAllowed = allowedRoutes.some(route => pathname.startsWith(route));

    if (isAllowed) {
        return children;
    }

    return <Navigate to="/"/>;
};
